import { SyncableState, mergeSyncable } from './merge';

// Storage port for per-user sync. Implemented over Firestore on device
// (see docs/accounts-and-sync.md) and faked in tests, so the data-critical
// orchestration below is unit-tested without a real backend.
export interface SyncStore {
  read: (uid: string) => Promise<SyncableState | null>;
  write: (uid: string, state: SyncableState) => Promise<void>;
}

// On sign-in: pull the remote copy, merge it with local (never loses data —
// see mergeSyncable), push the merged result back, and return it so the
// caller can update local state to match. When there's no remote copy yet
// (first device / new account) the local state is uploaded as-is.
export const syncOnSignIn = async (
  store: SyncStore,
  uid: string,
  local: SyncableState
): Promise<SyncableState> => {
  const remote = await store.read(uid);
  const merged = remote ? mergeSyncable(local, remote) : local;
  await store.write(uid, merged);
  return merged;
};

// While signed in: mirror local state to remote. Debouncing/batching is the
// caller's responsibility (GlobalState coalesces rapid edits before calling).
export const pushState = (
  store: SyncStore,
  uid: string,
  state: SyncableState
): Promise<void> => store.write(uid, state);

// Add dummy default export for Expo Router (every file under app/ needs one).
export default { syncOnSignIn, pushState };
